import styled from 'styled-components';
import { ClauseBlock } from './ClauseBlock';
import { AddVariantButton } from './AddVariantButton';
import { DeleteClauseButton, DeleteWrapper } from './DeleteClauseButton';
import { ElementIndexContextProvider, ElementType } from '../contexts/elementIndex';
import { useElseIfClausesWatch } from '../hooks/form';

const ClauseWrapper = styled.div`
  &:hover {
    ${DeleteWrapper} {
      display: flex;
    }
  }
`;

export const ElseIfContentList = () => {
  const clauses = useElseIfClausesWatch();
  return (
    <>
      {clauses.map((clause, index) => {
        return (
          <ElementIndexContextProvider key={clause.id} index={index} type={ElementType.clause}>
            <ClauseWrapper>
              <DeleteClauseButton />
              <ClauseBlock />
            </ClauseWrapper>
          </ElementIndexContextProvider>
        );
      })}
      <AddVariantButton />
    </>
  );
};
